import { Injector, NgModule } from '@angular/core';
import { FileReaderComponent } from './components/file-reader/file-reader.component';
import { ClassificationComponent } from './components/classification/classification.component';
import { SmartCanvasControlsComponent } from './components/smart-canvas-controls/smart-canvas-controls.component';
import { SmartCanvasGroupKeySelectionComponent } from './components/smart-canvas-group-key-selection/smart-canvas-group-key-selection.component';
import { SmartCanvasTooltipComponent } from './components/smart-canvas-tooltip/smart-canvas-tooltip.component';
import { SmartCanvasComponent } from './components/smart-canvas/smart-canvas.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { SharedModule } from '../shared/shared.module';
import { SmartCanvasTablesComponent } from './components/smart-canvas-tables/smart-canvas-tables.component';
import { SmartCanvasWordsComponent } from './components/smart-canvas-words/smart-canvas-words.component';
import { SmartCanvasSelectionAreaComponent } from './components/smart-canvas-selection-area/smart-canvas-selection-area.component';
import { SmartCanvasHighlightsComponent } from './components/smart-canvas-highlights/smart-canvas-highlights.component';
import { SmartCanvasPaginationComponent } from './components/smart-canvas-pagination/smart-canvas-pagination.component';
import { SmartCanvasOcrStatusComponent } from './components/smart-canvas-ocr-status/smart-canvas-ocr-status.component';
import { SmartCanvasLandmarksComponent } from './components/smart-canvas-landmarks/smart-canvas-landmarks.component';
import { FileReaderHeaderComponent } from './components/file-reader-header/file-reader-header.component';

@NgModule({
  declarations: [
    ClassificationComponent,
    FileReaderComponent,
    SmartCanvasComponent,
    SmartCanvasControlsComponent,
    SmartCanvasGroupKeySelectionComponent,
    SmartCanvasHighlightsComponent,
    SmartCanvasSelectionAreaComponent,
    SmartCanvasTooltipComponent,
    SmartCanvasTablesComponent,
    SmartCanvasWordsComponent,
    SmartCanvasPaginationComponent,
    SmartCanvasOcrStatusComponent,
    SmartCanvasLandmarksComponent,
    FileReaderHeaderComponent,
  ],
  imports: [SharedModule, FontAwesomeModule],
  exports: [FileReaderComponent],
})
export class ClassificationModule {
  constructor(private _injector: Injector) {}
}
